import styled, {keyframes} from 'styled-components';
import Image from '@stencil/image';
import {
  CenteredSpaceWrap,
  CenteredDivWrap,
  SectionHeader,
} from '../../../../CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

export const CaptivateBannerGalleryContainer = styled.div(
  props => `
  position:relative;
  display: flex;
  width: 590px;
  margin-right: 10px;
  margin-left: 'auto';
    `,
);

export const CaptivateBannerGallery = styled.div(
  props => `
  position:relative;
    `,
);

export const WideImageViewAllPhotosOuter = styled(CenteredDivWrap)(
  props => `
  position:relative;
  display: flex;
  min-width: 100%;
  // z-index: 999;
    `,
);

export const WideImageViewAllPhotos = styled(CenteredDivWrap)(
  props => `
  display:flex;
  flex-direction:column;
  height:75%;
  position: absolute;
  top: 14%;
  padding: ${props.theme.spacing.custom(16)};
  background:${props.theme.colors.shadow.base};
  border-radius:${props.theme.misc.borderRadius.custom(20)};
    `,
);

export const WideImageViewAllBtn = styled.button`
  ${textSizes.MediumW3}
  border:none;
  background: ${props => props.theme.colors.downriver.base};
  color: ${props => props.theme.colors.goWhite.base};
  border-radius: ${props => props.theme.misc.borderRadius.xxxlarge};
  padding: ${props => props.theme.spacing.custom(16)};
  margin-right: ${props => props.theme.spacing.custom(23)};
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
`;

export const ViewAllPhotosText = styled(SectionHeader)(
  props => `
  color:${props.theme.colors.goWhite.base};
  padding-bottom: ${props.theme.spacing.custom(27)};
    `,
);

export const WideImagePreviewWrap = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  // pointer-events: none;
  cursor: pointer;

    width:590px;
    position: absolute;
    top: 0;
    justify-content: space-between;
    height: 32rem;
    padding: ${props.theme.spacing.custom(16)};
    `,
);

export const HappyAngleRightIconWrap = styled(CenteredDivWrap)(
  props => `
    width:2.4rem;
    height:2.4rem;
    border-radius:${props.theme.misc.borderRadius.round};
    background:${props.theme.colors.goWhite.base};
    cursor: pointer;
    border: .1rem solid ${props.theme.colors.downriver.base};
    `,
);

export const CaptivateGalleryImage = styled(Image)(
  props => `
  width:100%;
  height:32rem;
  object-fit: cover;
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  min-width: ${props.listItemWidth || '50%'};
    `,
);

export const LeftIconWrapper = styled.div(
  props => `
    position: absolute;
    left: 1.6rem;
    top: 50%;
  `,
);

export const CaptivateImageWrapper = styled.div(
  props => `
  width:100%;
  height:32rem;
  min-width: ${props.listItemWidth || '100%'};
  position: relative;
    `,
);

export const CaptivateBannerOuterContainer = styled.div(
  props => `
  overflow: hidden;
  position: relative;
  width: 590px;
  margin-right: 10px;
    `,
);

export const CaptivateGalleryImageViewAll = styled(CaptivateGalleryImage)(
  props => `
  filter: blur(2px);
    `,
);

export const CaptivateGalleryOverlayTabWrap = styled.div(
  props => `
  display:flex;
  justify-content: flex-end;
  cursor: pointer;
  z-index: 1;
    `,
);

export const CaptivateGalleryOverlayTab = styled.div(
  props => `
  display:flex;
  border-radius:${props.theme.misc.borderRadius.base};
  background:${props.theme.colors.shadow.dark};
  padding: ${props.theme.spacing.small};
  margin-right:${props.theme.spacing.custom(12)};
  &:last-child{
    margin-right:0;
  }
  >p{
    font-weight: 600;
    color:${props.theme.colors.goWhite.base};
    user-select:none;
  }
    `,
);

export const CaptivateBannerGalleryRoomTagContainer = styled.div(
  props => `
  max-width:30%;
  text-align:center;
  margin-right:${props.theme.spacing.custom(18)};
    `,
);

export const CaptivateBannerGalleryRoomTYpeTag = styled.div(
  props => `
    color:${props.theme.colors.goWhite.base};
    margin-bottom:${props.theme.spacing.custom(8)};
    &.selectedTag{
      font-weight: 600;
      font-size: ${props.theme.font.custom(16)};
      color:${props.theme.colors.goYellow.base};
    }
    `,
);

export const CaptivateProgressBarWrap = styled.div(
  props => `
  height: .2rem;
  position: relative;
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000 86%);
  overflow: hidden;
  span{
    display: block;
    height: 100%;
    width:100%;
  }
    `,
);

const progressBar = keyframes`
    0%   { width: 0; }
    100%  { width: 100; }
`;

export const CaptivateProgressBarAnimate = styled.span`
  &.selectedProgressBar {
    background: ${props => props.theme.colors.goYellow.base};
  }
  animation-name: ${progressBar};
  animation-fill-mode: both;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
`;
